import React, { createContext, useReducer, useContext, ReactNode } from 'react';

import { OrganizationsDetails } from '@verantos-dev/data-access-organizations';

enum DialogActionType {
  OPEN_DIALOG = 'OPEN_DIALOG',
  CLOSE_DIALOG = 'CLOSE_DIALOG',
}

type DialogType = 'createOrganization' | 'editOrganization' | 'selectDatasets' | null;

type OrganizationsListDialogState = {
  activeDialog: DialogType;
  data?: OrganizationsDetails | null;
};

type OrganizationsListDialogAction =
  | { type: DialogActionType.OPEN_DIALOG; payload: DialogType; data?: OrganizationsDetails | null }
  | { type: DialogActionType.CLOSE_DIALOG };

const initialState: OrganizationsListDialogState = {
  activeDialog: null,
  data: null,
};

const OrganizationsListDialogContext = createContext<{
  state: OrganizationsListDialogState;
  dispatch: React.Dispatch<OrganizationsListDialogAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const dialogReducer = (
  state: OrganizationsListDialogState,
  action: OrganizationsListDialogAction
): OrganizationsListDialogState => {
  switch (action.type) {
    case DialogActionType.OPEN_DIALOG:
      return { ...state, activeDialog: action.payload, data: action.data ?? null };
    case DialogActionType.CLOSE_DIALOG:
      return { ...state, activeDialog: null, data: null };
    default:
      return state;
  }
};

export const OrganizationsListDialogProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(dialogReducer, initialState);

  return (
    <OrganizationsListDialogContext.Provider value={{ state, dispatch }}>
      {children}
    </OrganizationsListDialogContext.Provider>
  );
};

export const useOrganizationsListDialogContext = () => useContext(OrganizationsListDialogContext);
export { DialogActionType, DialogType };
